import {
  IInputBase,
  IInputHint,
  IInputLabel,
  IInputWrapper,
} from 'interfaces/forms/_base';
import { RadixTextFieldSize } from 'lib_ts/enums/radix-ui';

export interface ITime {
  // 0-23
  h: number;

  // 0-59
  m: number;

  // e.g. -5 for EST
  offset: number;
}

export const getTimeFromDate = (value: Date, nearestMin: number): ITime => {
  const o: ITime = {
    h: value.getHours(),
    m: Math.floor(value.getMinutes() / nearestMin) * nearestMin,
    // convert minutes to hours
    offset: -value.getTimezoneOffset() / 60,
  };

  return o;
};

export interface IDateWidget {
  minDate?: Date;
  maxDate?: Date;

  // yyyy-mm-dd format, i.e. LOCAL_DATE_FORMAT
  allowedDates?: string[];
}

export interface IDateInput
  extends IInputBase,
    IInputLabel,
    IInputHint,
    IInputWrapper,
    IDateWidget {
  defaultValue?: Date;
  showTime?: boolean;

  displayFormat?: string;

  onChange: (value: Date | undefined) => void;

  size?: RadixTextFieldSize;
}

export interface IDateRangeInput
  extends IInputBase,
    IInputLabel,
    IInputHint,
    IInputWrapper,
    IDateWidget {
  defaultStartValue?: Date;
  defaultEndValue?: Date;

  showTime?: boolean;

  displayFormat?: string;

  onChange: (
    value:
      | Partial<{
          start: Date;
          end: Date;
        }>
      | undefined
  ) => void;

  size?: RadixTextFieldSize;

  // whether to deferred the onChange event until the picker is closed
  onChangeOnClose?: boolean;
}
